import { z } from "zod";

export const accessGroupSchemaFactory = () => {
    const schema = z.object({
        id: z.string({ required_error: "ObjectID is required" }).min(1, { message: "ObjectID is required" }),
        name: z.string({ required_error: "Group Name is required" }).min(1, { message: "Group Name is required" }),
        active: z.boolean().optional(),
        customerIds: z.array(z.string(), { required_error: "At least one Customer is required" }).min(1, { message: "At least one Customer is required" })
    });

    return schema;
};

export type AccessGroupFormModel = z.infer<ReturnType<typeof accessGroupSchemaFactory>>;
